"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _getEarlyRequesterResultPromise = _interopRequireDefault(require("../getEarlyRequesterResultPromise"));

var DOMAIN_URI = 'cos-domains/v1/domains/settings';
var BLOG_DOMAINS_URI = 'cos-domains/v1/domains/for-blog-settings';
var BRAND_DOMAINS_URI = '/cos-domains/v1/brands';

var DomainsAPI =
/*#__PURE__*/
function () {
  function DomainsAPI() {
    (0, _classCallCheck2.default)(this, DomainsAPI);
  }

  (0, _createClass2.default)(DomainsAPI, null, [{
    key: "getDomains",
    value: function getDomains() {
      return _apiClient.default.get(DOMAIN_URI, {
        query: {
          skipdnscheck: true
        }
      });
    }
  }, {
    key: "getDomainsForBlogs",
    value: function getDomainsForBlogs() {
      return (0, _getEarlyRequesterResultPromise.default)('blog-domains') || _apiClient.default.get(BLOG_DOMAINS_URI, {
        query: {
          skipdnscheck: true
        }
      });
    }
  }, {
    key: "getBrandDomains",
    value: function getBrandDomains() {
      return _apiClient.default.get(BRAND_DOMAINS_URI);
    }
  }]);
  return DomainsAPI;
}();

exports.default = DomainsAPI;
module.exports = exports.default;